module.exports = __webpack_public_path__ + "fonts/DM_Sans-200-latin5.7c87a64.woff2";